/**
 * Define action type for classrooms module
 */
export const GET_CLASSROOMS = 'course_classrooms/GET_CLASSROOMS';
export const GET_CLASSROOMS_SUCCESS =
  'course_classrooms/GET_CLASSROOMS_SUCCESS';
export const GET_CLASSROOMS_FAILED = 'course_classrooms/GET_CLASSROOMS_FAILED';
